










































import BaseFormMixin from '@/mixins/base-form-mixin';
import { DatasourceDto } from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Component, PropSync } from 'vue-property-decorator';

@Component
export default class FileConfForm extends mixins(BaseFormMixin) {
  @PropSync('formData') syncFormData!: DatasourceDto;

  mounted() {
    this.syncFormData.fileConfig = {
      filePosition: '',
      fileSource: '',
      encoding: 'UTF-8',
      frequency: '',
      fileExtension: 'csv',
      ignoreFirstLine: false,
      delimiter: ',',
      dateSort: '1'
    };
  }
}
